var map = {
	"./ai.svg": 4936,
	"./electronics.svg": 5755,
	"./informatics.svg": 5805,
	"./materials.svg": 4068,
	"./physics.svg": 1529,
	"./telecommunications.svg": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3836;